<template>
  <div class="contain">
    <div class="qyfw">
      <h4 class="title">企业服务</h4></h4>
       <div>
         <el-button type="info" size="mini">超小按钮</el-button>
       </div>
    </div>
    <el-card class="el-card">
      <ul class="list_box">
        <li @click="tolist">
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
         <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
         <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
          <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
          <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
          <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
        <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
        <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
        <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
        <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
        <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
        <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
        <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
        <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
        <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
        <li>
         <div class="pics">
            <img src="../../assets/image/avater.png" alt="">
         </div>
        </li>
      </ul>
    </el-card>
    <!-- 分页 -->
    <div class="fenye">
      <el-pagination
  background
  layout="prev, pager, next"
  :total="1000">
</el-pagination>
    </div>
  </div>
</template>

<script>
export default {

  created () {

  },
  methods: {
    tolist () {
      this.$router.push('/serviseList')
    }
  },
  computed: {

  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .qyfw {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 21px;
    border-bottom: 1px solid #e8e8e8;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .el-card {
    flex: 1;
    margin-top: 23px;
    .list_box {
      // margin: 46px 70px;
      li {
        float: left;
        width: 21.25%;
        text-align: center;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        margin-right: 5%;
        // position: relative;
        margin-bottom: 46px;

        .pics {
          width: 100%;
          padding-bottom: 52%;
          position: relative;
        }
        img {
          position: absolute;
          left: 50%;
          transform: translate(-50%);
          max-width: 100%;
          height: 80%;
          margin-top: 5%;

          // width: 100%;
          // height: 100%;
        }
        &:nth-child(4n) {
          margin-right: 0px;
        }
      }
    }
  }
  .fenye {
    text-align: right;
    margin-top: 20px;
  }
}
</style>